/*
- Palo Alto Theme
*
- Use this file to add custom Javascript to Palo Alto.
*/

(function() {
  function parseEuroPrice(text) {
    if (!text) return 0;

    const cleaned = text
      .replace(/[^\d,.-]/g, '')
      .replace(/\./g, '')
      .replace(',', '.');

    const value = parseFloat(cleaned);
    return Number.isNaN(value) ? 0 : value;
  }

  function formatEuroPrice(value) {
    return '€' + value.toLocaleString('de-DE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }) + ' EUR';
  }

  function normalize(value) {
    return (value || '')
      .toLowerCase()
      .trim()
      .replace(/\s+/g, ' ');
  }

  function findPriceElement() {
    return document.querySelector('[data-product-price]');
  }

  function fixComparePrice() {
    document
      .querySelectorAll(
        '.product__price [data-compare-price], .product__price .product__price--compare, .product__price s, .product__price del'
      )
      .forEach(function(el) {
        if (!el.textContent.trim()) return;

        el.style.setProperty('display', 'inline-block', 'important');
        el.style.setProperty('text-decoration', 'line-through', 'important');
        el.style.setProperty('text-decoration-thickness', '1px', 'important');
        el.style.setProperty('text-decoration-color', 'currentColor', 'important');
        el.style.setProperty('opacity', '0.55', 'important');
      });
  }

  function findPersonalizationSelect() {
    return (
      document.querySelector('select[name="properties[Personalisierung]"]') ||
      document.querySelector('select[id^="Personalisierung-"]') ||
      document.querySelector('select[name*="Personalisierung"]') ||
      document.querySelector('select[name*="Personalization"]')
    );
  }

  function findGiftboxSelect() {
    return (
      document.querySelector('select[name="properties[Geschenk-Holzbox für Lederschürze]"]') ||
      document.querySelector('select[name="properties[Geschenkbox]"]') ||
      document.querySelector('select[id^="Geschenk"]') ||
      document.querySelector('select[name*="Geschenk"]') ||
      document.querySelector('select[name*="Gift"]')
    );
  }

  function isPersonalizationSelected(value) {
    const v = normalize(value);

    return (
      v === 'mit personalisierung' ||
      v === 'plus personalisierung' ||
      v === 'personalisierung hinzufügen' ||
      v === 'with personalization' ||
      v === 'add personalization'
    );
  }

  function isGiftboxSelected(value) {
    const v = normalize(value);

    return (
      v === 'mit geschenkbox' ||
      v === 'geschenkbox hinzufügen' ||
      v === 'plus geschenkbox' ||
      v === 'mit geschenk-holzbox' ||
      v === 'with gift box' ||
      v === 'add gift box'
    );
  }

  function updateLiveProductPrice() {
    const priceEl = findPriceElement();
    if (!priceEl) return;

    if (!priceEl.dataset.basePrice) {
      priceEl.dataset.basePrice = String(parseEuroPrice(priceEl.textContent));
    }

    const basePrice = parseFloat(priceEl.dataset.basePrice || '0');

    const personalizationSelect = findPersonalizationSelect();
    const giftboxSelect = findGiftboxSelect();

    let extra = 0;

    if (personalizationSelect && isPersonalizationSelected(personalizationSelect.value)) {
      extra += 20;
    }

    if (giftboxSelect && isGiftboxSelected(giftboxSelect.value)) {
      extra += 30;
    }

    priceEl.textContent = formatEuroPrice(basePrice + extra);
  }

  function bindSelect(select) {
    if (!select || select.dataset.livePriceBound === 'true') return;

    select.addEventListener('change', updateLiveProductPrice);
    select.addEventListener('input', updateLiveProductPrice);
    select.dataset.livePriceBound = 'true';
  }

  function bindLivePriceEvents() {
    bindSelect(findPersonalizationSelect());
    bindSelect(findGiftboxSelect());
    updateLiveProductPrice();
    fixComparePrice();
  }

  function bootLivePrice() {
    bindLivePriceEvents();

    setTimeout(fixComparePrice, 300);
    setTimeout(fixComparePrice, 1000);
    setTimeout(fixComparePrice, 2000);

    let debounceTimer;

    const observer = new MutationObserver(function() {
      window.clearTimeout(debounceTimer);
      debounceTimer = window.setTimeout(function() {
        bindLivePriceEvents();
      }, 80);
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    window.addEventListener('pageshow', bindLivePriceEvents);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootLivePrice);
  } else {
    bootLivePrice();
  }
})();

/*
- MERGEL: show the measurements next to the Größe selector.
- Trays update when the customer switches Klein / Groß.
- The SAIL Leder-Wandtasche is one size and each colour is its own
- product with a single variant, so it has no selector at all and its
- line is placed under the price instead.
*
- On the live shop the size buttons are rendered by the EVS swatches app
- (.sg__ classes). EVS does NOT load in Shopify theme previews, where the
- theme's own fieldset.radio__fieldset markup shows instead, so both are
- supported. Everything is re-applied from a MutationObserver because EVS
- re-renders its swatches after a variant change.
*/

(function() {
  var SIZED = {
    'wave-lederablage': { klein: '26 × 17 × 4 cm', gross: '35 × 23 × 5 cm' },
    'reef-lederablage': { klein: '20 × 20 × 4 cm', gross: '29 × 29 × 5 cm' },
    'cove-lederablage': { klein: '18 × 18 × 3 cm', gross: '26 × 26 × 3 cm' }
  };

  var SINGLE = {
    'sail-leder-wandtasche': '38 × 29 cm'
  };

  var MARKER = 'mergel-dimensions';

  function handle() {
    var m = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : '';
  }

  function matchKey(table) {
    var h = handle();
    for (var key in table) {
      if (Object.prototype.hasOwnProperty.call(table, key) && h.indexOf(key) === 0) {
        return key;
      }
    }
    return null;
  }

  function sizeKey(label) {
    var v = (label || '').toLowerCase().trim();
    if (v.indexOf('klein') === 0) return 'klein';
    if (v.indexOf('gro') === 0) return 'gross';
    return null;
  }

  function makeNode() {
    var node = document.createElement('span');
    node.className = MARKER;
    node.style.display = 'block';
    node.style.marginTop = '4px';
    node.style.fontSize = '0.85em';
    node.style.opacity = '0.75';
    return node;
  }

  function startsWithGroesse(text) {
    return /^größe/i.test((text || '').trim());
  }

  /*
   - Finds the size selector in whichever markup is present.
   - Returns { anchor, value } where anchor is the node to insert after.
   */
  function findSizeSelector() {
    var evs = document.querySelectorAll('.sg__swatch_option-label');
    for (var i = 0; i < evs.length; i++) {
      if (startsWithGroesse(evs[i].textContent)) {
        var picked = evs[i].querySelector('.sg__swatch_option_label-variant');
        return { anchor: evs[i], value: picked && picked.textContent };
      }
    }

    var sets = document.querySelectorAll('fieldset.radio__fieldset');
    for (var j = 0; j < sets.length; j++) {
      var legend = sets[j].querySelector('.radio__legend');
      if (legend && startsWithGroesse(legend.textContent)) {
        var checked = sets[j].querySelector('.radio__input:checked');
        var label = checked && checked.nextElementSibling;
        return { anchor: sets[j], value: label && label.textContent };
      }
    }

    return null;
  }

  function renderSized(key) {
    var found = findSizeSelector();
    if (!found || !found.anchor) return;

    var size = sizeKey(found.value);
    if (!size) return;

    var value = SIZED[key][size];
    if (!value) return;

    var parent = found.anchor.parentNode;
    if (!parent) return;

    var node = parent.querySelector(':scope > .' + MARKER);
    if (!node) {
      node = makeNode();
      parent.insertBefore(node, found.anchor.nextSibling);
    }

    if (node.textContent !== value) node.textContent = value;
  }

  function renderSingle(key) {
    var anchor =
      document.querySelector('.sg__swatch_option-wrapper') ||
      document.querySelector('.product__selectors') ||
      document.querySelector('.product__price');
    if (!anchor || !anchor.parentNode) return;
    if (anchor.parentNode.querySelector(':scope > .' + MARKER)) return;

    var node = makeNode();
    node.textContent = 'Maße: ' + SINGLE[key];
    anchor.parentNode.insertBefore(node, anchor.nextSibling);
  }

  function render() {
    var sized = matchKey(SIZED);
    if (sized) { renderSized(sized); return; }

    var single = matchKey(SINGLE);
    if (single) renderSingle(single);
  }

  function boot() {
    if (!matchKey(SIZED) && !matchKey(SINGLE)) return;

    render();

    var timer;
    new MutationObserver(function() {
      window.clearTimeout(timer);
      timer = window.setTimeout(render, 60);
    }).observe(document.body, { childList: true, subtree: true });

    window.addEventListener('pageshow', render);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
